import styled, { css } from 'styled-components';
import { NoSelect } from '../../../../../styles/mixins';

export const LabelStyled = styled.div<{ hasDiagram: boolean }>`
  position: relative;
  line-height: 24px;
  font-weight: 600;
  padding-bottom: 8px;
  ${NoSelect};

  ${({ hasDiagram }) =>
    hasDiagram &&
    css`
      padding-bottom: 48px;
    `}
`;
